// extracted by mini-css-extract-plugin
module.exports = {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__2p0yW","subTitleBold":"BoxSubTitle_subTitleBold__1ILLO"};